<template>
  <div class="app-footer-pc common-layout">
    <div class="app-footer-content">
      <!-- ★修改：在 manshonRegist / inquary 时，footer logo 不可点击 -->
      <a
        v-if="isLogoClickable"
        class="app-footer-logo"
        @click.prevent="goLoginWithManshonId"
      ></a>
      <span
        v-else
        class="app-footer-logo app-footer-logo--disabled"
        aria-disabled="true"
      ></span>

      <div class="app-footer-list">
        <div class="app-footer-list-item-minor-wrap">
          <a class="app-footer-list-item-minor" href="/privacy.html" target="_blank">個人情報保護方針</a>
          <span class="app-footer-list-item-minor-divider"></span>
          <a class="app-footer-list-item-minor" href="/terms.html" target="_blank">利用規約</a>
          <span class="app-footer-list-item-minor-divider"></span>
          <!-- <a class="app-footer-list-item-minor" href="/disclaimer.html" target="_blank">免責事項</a> -->
          <!-- <a class="app-footer-list-item-minor">免責事項</a>
          <span class="app-footer-list-item-minor-divider"></span> -->
          <!-- <a class="app-footer-list-item-minor" href="/recommendedBrowser.html" target="_blank">推奨ブラウザ</a>
          <span class="app-footer-list-item-minor-divider"></span> -->
          <a class="app-footer-list-item-minor" href="https://www.smapay.co.jp/" target="_blank">運営会社</a>
        </div>
      </div>
    </div>
    <br>
    <div class="app-footer-copyright">
      <span>Copyright Ⓒ 2026 すまてっく株式会社 All rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import guideImg from '@/assets/guide.png';
import howtoImg from '@/assets/howto.png';
import myPageLogo from '@/assets/user.png';

export default {
  name: 'PCFooter',
  data() {
    return {
      guideImg,
      myPageLogo,
      howtoImg,
    };
  },
  computed: {
    // ★新增：logo点击可否
    isLogoClickable() {
      const href = window.location.href || '';
      return !(href.indexOf('manshonRegist') !== -1 || href.indexOf('inquary') !== -1);
    },
  },
  methods: {
    goLoginWithManshonId() {
      // ★保险：即使误触也不跳转
      const href = window.location.href || '';
      if (href.indexOf('manshonRegist') !== -1 || href.indexOf('inquary') !== -1) return;

      const manshonId = localStorage.getItem('sessionManshonId');
      this.$router.push({ path: '/board', query: { manshonId } });
    },
  },
};
</script>

<style lang="less" scoped>
  .el-footer .app-footer-pc {
    padding: 20px 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    background: #d4ecf4;
    color: #0f3264;

    .app-footer-content{
      display: flex;
      justify-content: center;

      .app-footer-logo {
        width: 200px;
        height: 120px;
        display: block;
        background: url(../assets/wan-nyan-mate_logo_tate.png) no-repeat;
        background-size: contain;
        background-position: center;
      }

      /* ★新增：不可点击样式 */
      .app-footer-logo--disabled {
        cursor: default;
        pointer-events: none;
        opacity: 0.9;
      }

      .app-footer-list {
        flex: 1;
        display: flex;
        flex-direction: column;

        .app-footer-list-item-major-wrap {
          display: flex;
          justify-content: space-around;
          margin-bottom: 25px;
          padding: 0 20px;

          .app-footer-list-item-major a {
            display: flex;
            align-items: center;
            color: rgb(15, 51, 100);
            font-weight: bold;
            height: 30px;
            line-height: 30px;

            .el-avatar {
              background-color: transparent;
            }
          }
        }

        .app-footer-list-item-minor-wrap {
          display: flex;
          justify-content: space-around;
          padding: 0 20px;

          .app-footer-list-item-minor {
            text-align: center;
            font-size: 14px;
            color: rgb(15, 51, 100);
            font-weight: bold;
          }
          .app-footer-list-item-minor-divider {
            display: inline-block;
            height: 100%;
            width: 1px;
            border-right: solid 1px rgb(15, 51, 100);
          }
        }
      }
    }

    .app-footer-copyright {
      margin-top: 5px;
      margin-bottom: 10px;
      text-align: center;

      span {
        vertical-align: middle;
        font-size: 12px;
      }
      .el-link {
        color: #0f3264;

        &:hover {
          color: #409EFF;
        }
      }
    }
  }
  @media (max-width: 767px) {
    #app {
      .el-footer .app-footer-pc {
        display: none;
      }
    }
  }
</style>
